const API = "https://mys-back.onrender.com";

export function setToken(token) {
  localStorage.setItem("mys_token", token);
}

export function getToken() {
  return localStorage.getItem("mys_token");
}

export function logout() {
  localStorage.removeItem("mys_token");
}

export async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = {  ...(options.headers || {})
  };
   if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }
  if (token) headers.Authorization = `Bearer ${token}`;

  return fetch(`${API}${path}`, { ...options, headers });
}
